
interface PropertySpecsProps {
  property: {
    bedrooms: number;
    bathrooms: number;
    parking: number;
    area: number;
    livingRooms: number;
    kitchens: number;
    floors: number;
  };
}

export const PropertySpecs = ({ property }: PropertySpecsProps) => {
  // Guard against missing or malformed property data
  if (!property) {
    return null; // or render a fallback UI
  }

  const specs = [
    { icon: 'ri-hotel-bed-line', label: 'Bedrooms', value: property.bedrooms },
    { icon: 'ri-shower-line', label: 'Bathrooms', value: property.bathrooms },
    { icon: 'ri-car-line', label: 'Parking', value: property.parking },
    { icon: 'ri-home-4-line', label: 'Area (acres)', value: property.area },
    { icon: 'ri-sofa-line', label: 'Living Rooms', value: property.livingRooms },
    { icon: 'ri-restaurant-line', label: 'Kitchens', value: property.kitchens },
    { icon: 'ri-building-line', label: 'Floors', value: property.floors },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        Property Specifications
      </h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {specs.map((spec, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-lg"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-3">
              <i className={`${spec.icon} text-2xl text-teal-600`}></i>
            </div>

            <div className="text-2xl font-bold text-gray-900 mb-1">
              {spec.value}
            </div>

            <div className="text-sm text-gray-600">{spec.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
